import { render, staticRenderFns } from "./button_list_m.vue?vue&type=template&id=37efbfdc&scoped=true&"
import script from "./button_list_m.vue?vue&type=script&lang=js&"
export * from "./button_list_m.vue?vue&type=script&lang=js&"
import style0 from "./button_list_m.vue?vue&type=style&index=0&id=37efbfdc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37efbfdc",
  null
  
)

export default component.exports